import React, { useState, useRef, useEffect } from 'react';
import {
	Flex,
	Tooltip,
	Text,
	Button,
	useToast,
	Box,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
} from '@chakra-ui/react';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import c from '../constant';
import DownloadAndViewButton from './Files/DownloadAndViewButton';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
const maxFileSize = 10485760 * 10;

export default function UploadFile({ fileExist, disable, loading, loadingRemoveFile, fileContent, removeFile }) {
	const { t, i18n } = useTranslation();
	const currentLang = i18n.language;
	const toast = useToast();
	const fileInput = useRef(null);

	const [attachmentFile, setAttachmentFile] = useState(null);
	const [isOpen, setIsOpen] = React.useState(false);
	const onClose = () => setIsOpen(false);
	const cancelRef = React.useRef();

	const handleFileChange = (event) => {
		var fileInput = false;
		if (event.target.files[0]) {
			fileInput = true;
		}
		if (fileInput) {
			const file = event.target.files[0];
			if (file.size > maxFileSize) {
				toast({
					title: t('File size over limit'),
					status: 'warning',
					isClosable: true,
					position: 'top-right',
				});
			} else {
				setAttachmentFile(event.target.files[0]);
			}
		}
	};

	const handleClickFile = () => {
		fileInput.current.click();
	};

	function SubmitFile() {
		if (attachmentFile) {
			const fileData = {
				attachmentFile: attachmentFile,
				attachmentFileSize: attachmentFile?.size,
			};
			fileContent(fileData);
		}
	}

	return (
		<>
			<Flex direction="row" alignItems="center" pl="2" className="hidden-print">
				{fileExist ? (
					<Flex>
						<Flex className="viewContainer" alignItems="center" mt="2" mb="2">
							<DownloadAndViewButton url={fileExist?.file} size={fileExist?.fileSize} marginLeft={0} />
							<FontAwesomeIcon
								onClick={() => {
									if (!disable) {
										setIsOpen(true);
									}
								}}
								className="remove"
								icon={faMinusSquare}
								style={{
									fontSize: 18,
									display: 'none',
									position: 'absolute',
									zIndex: '100',
									marginLeft: 160,
									marginBottom: 30,
									color: 'red',
									backgroundColor: 'white',
									padding: 2,
									cursor: 'pointer',
								}}
							/>
						</Flex>
					</Flex>
				) : (
					<Flex>
						<Flex
							maxW={480}
							borderRadius={c.borderRadius}
							pr="2"
							pl="2"
							h="37px"
							bg="blue.400"
							cursor="pointer"
							alignItems="center"
							onClick={() => {
								if (!disable) {
									if (!loading) {
										handleClickFile();
									}
								}
							}}
						>
							<Text minW="122px" w="122px" color="white">
								{t('Choose Attachment')}
							</Text>
							<FontAwesomeIcon icon={faFile} color="white" style={{ fontSize: 18, marginLeft: 4 }} />
							{attachmentFile?.name && (
								<Text noOfLines={1} bg="gray.200" pl="2" pr="2" ml="2">
									{attachmentFile?.name}
								</Text>
							)}
						</Flex>
						<input style={{ display: 'none' }} type="file" onChange={(e) => handleFileChange(e)} ref={fileInput} />
					</Flex>
				)}
				{attachmentFile?.name && !fileExist && (
					<Flex justifyContent="flex-end">
						<Button color="#3498DA" isLoading={loading} onClick={() => SubmitFile()}>
							{t('Submit')}
						</Button>
					</Flex>
				)}
			</Flex>
			<>
				<>
					<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Delete File')}
								</AlertDialogHeader>

								<AlertDialogBody>{t("Are you sure? You can't undo this action afterwards")}</AlertDialogBody>

								<AlertDialogFooter>
									<Button ref={cancelRef} disabled={loadingRemoveFile} onClick={onClose}>
										{t('Cancel')}
									</Button>
									<Button
										isLoading={loadingRemoveFile}
										colorScheme="red"
										onClick={() => {
											removeFile();
										}}
										ml={3}
									>
										{t('Delete')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>
				</>
			</>
		</>
	);
}
